/** Made-up billboard ads in the Accra style. */
export const BILLBOARDS: readonly { title: string; line: string; bg: string; fg: string; accent: string }[] = [
  { title: 'DUKUS BAKERY', line: 'Your bakery is our concern', bg: '#ffcc00', fg: '#1b1b1b', accent: '#004f9f' },
  { title: 'MYSCHOOLGH.COM', line: 'Attendance, online lessons & more', bg: '#2b1b12', fg: '#ffd166', accent: '#ce1126' },
  { title: 'DUKUS BAKERY', line: "You're welcome to our bakery!", bg: '#006b3f', fg: '#ffffff', accent: '#fcd116' },
  { title: 'JAUNTY BAGS & SHOES', line: 'Your fashion & lifestyle store.', bg: '#f77f00', fg: '#ffffff', accent: '#3d0c02' },
  { title: 'LEXORADOCS.COM', line: 'Your law case management service.', bg: '#0b3954', fg: '#ffffff', accent: '#bfd7ea' },
  { title: 'MYSCHOOLGH.COM', line: 'School fees made easy', bg: '#e63946', fg: '#ffffff', accent: '#f1faee' },
];
